import truncate from 'lodash/truncate';

export function displayUserRoles(jobRoles) {
  return truncate(jobRoles.map((role) => role.formattedRoleName).join(', '), { length: 65 });
}
